// extracted by mini-css-extract-plugin
export const contentContainer = "about-module--contentContainer--qDzld";
export const image = "about-module--image--3S926";
export const header = "about-module--header--143uk";
export const description = "about-module--description--3zNuD";
export const buttons = "about-module--buttons--2Ldoe";
export const btnIcon = "about-module--btnIcon--2rer6";